import { useSafeTimeout } from '@/app/shared/ssr-util';
import { isPlatformBrowser } from '@angular/common';
import { Component, EventEmitter, Inject, Input, Output, PLATFORM_ID, TemplateRef, ViewChild } from '@angular/core';
import { ModalDismissReasons, NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-announce-popup',
  templateUrl: './announce-popup.component.html',
  styleUrls: ['./announce-popup.component.scss']
})
export class AnnounceModalComponent {
  public closeResult: string;
  public modalOpen: boolean = false;
  @Input() imageUrl = '';
  @Input() title = 'đâsd';
  @Input() message = 'ádasd';
  @Input() buttonText = 'Đã hiểu';

  @Output() confirmed = new EventEmitter<any>();

  @ViewChild("announceModal", { static: false }) announceModal: TemplateRef<any>;

  private safeTimeout = useSafeTimeout();
  
  constructor(
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  async openModal() {
    if (isPlatformBrowser(this.platformId)) { // For SSR
      this.modalOpen = true;
      this.modalService.open(this.announceModal, {
        ariaLabelledBy: 'Confirmation-Modal',
        centered: true,
        windowClass: 'theme-modal text-center'
      }).result.then((result) => {
        `Result ${result}`
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        this.confirm(false);
      });
    }
  }

  private getDismissReason(reason: ModalDismissReasons): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  confirm(value: boolean) {
    this.confirmed.emit(value);
    this.modalService.dismissAll();
  }

  onConfirm(modal: any) {
    this.confirmed.emit(true);
    modal.close('OK');
    this.safeTimeout(() => {
      const element = document.getElementById('transport-method-section');
      if (element) {
        const offset = 120;
        const top =
          element.getBoundingClientRect().top +
          window.pageYOffset -
          offset;

        window.scrollTo({
          top,
          behavior: 'smooth'
        });
      }
    }, 300);
}

  onButtonClick() {
    this.confirmed.emit();
    this.activeModal.close(true);
  }

   ngOnDestroy() {
    if (this.modalOpen) {
      this.modalService.dismissAll();
    }
  }
}
